export type RemoteViewHost = {
  wrapper: HTMLElement
  videoHost: HTMLElement
  dragHost: HTMLElement
}

export function createRemoteViewHost(wrapper: HTMLElement): RemoteViewHost {
  const computed = getComputedStyle(wrapper)
  if (computed.position === 'static') {
    wrapper.style.position = 'relative'
  }

  const videoHost = document.createElement('div')
  videoHost.setAttribute('data-xmax-remote-video', 'true')
  videoHost.style.cssText =
    'position:relative;z-index:0;width:100%;height:100%;overflow:hidden;display:flex;align-items:center;justify-content:center;'

  const dragHost = document.createElement('div')
  dragHost.setAttribute('data-xmax-drag-surface', 'true')
  dragHost.style.cssText =
    'position:absolute;inset:0;z-index:20;pointer-events:none;touch-action:auto;'

  wrapper.replaceChildren()
  wrapper.appendChild(videoHost)
  wrapper.appendChild(dragHost)

  return { wrapper, videoHost, dragHost }
}
